<div class="modal-alert">

	<div class="modal-header">
        <div class="d-flex flex-row justify-content-center align-items-center">
            <span class="material-icons custom-modal-confirmation-icon me-2">info</span>
            <span class="fs-5 fw-bold">Información</span>
        </div>
	</div>

	<div class="modal-body">
		<div class="container">
			<div class="row">
                <div [innerHTML]="message.join('')"></div>
            </div>
		</div>
	</div>

	<div class="modal-footer">

        <button type="button" class="btn custom-modal-confirmation-button" (click)="okButtonController()">
            <div class="d-flex flex-row justify-content-center align-items-center">
                <span class="material-icons">done</span>
			    <span>Aceptar</span>
            </div>
        </button>
		
	</div>
	
</div>
